var React = require('react');

function TopBanner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m0 81.643c57.238-0.56671 96.253-8.5352 106.48-43.453 10.228-34.918 103.52-38.19 103.52-38.19h-210z","fill":"#3290ff","strokeWidth":"0"}));
}

TopBanner.defaultProps = {"width":"210mm","height":"81.643mm","version":"1.1","viewBox":"0 0 210 81.643"};

module.exports = TopBanner;

TopBanner.default = TopBanner;
